import React from "react";
import "./InvestmentSection.css";
import AboutImage from "../../Image/FPOImgae/InvestmentImage.png";

export default function InvestmentSection() {
  return (
    <section className="fpo-excellence-section">
      <div className="fpo-excellence-container">

        {/* LEFT – IMAGE */}
        <div className="fpo-excellence-col fpo-excellence-left">
          <div className="fpo-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Financial Process Outsourcing"
              className="fpo-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="fpo-excellence-col fpo-excellence-right">
          <div className="fpo-excellence-content">

            <h2 className="fpo-excellence-title">
             Innovative Investment Advisory Services
            </h2>

            <p className="fpo-excellence-text">
              Safe & High-Yield Opportunities
Are you tired of traditional investment options like mutual funds and low-yield bonds? Our Innovative Investment Advisory Services offer tailored, secure, and profitable strategies that go beyond the ordinary. With a focus on safety and growth, our products consistently deliver returns at least 50% higher than conventional secured investments, helping you achieve your financial goals with confidence.
            </p>

            {/* SERVICES LIST */}
            <ul className="fpo-excellence-list">
           
            </ul>

          </div>
        </div>

      </div>
      <p>
          Why Choose Our Investment Advisory?<br/>
             <br/>
Innovative Solutions: We specialize in unique investment opportunities that combine safety and high returns. Our strategies are crafted to outperform traditional products without compromising on risk factors.
<br/><br/>Enhanced Safety: Our advisory focuses on low-risk, high-reward opportunities, ensuring that your capital remains secure while generating substantial growth.
<br/><br/>Expertise You Can Trust: Our experienced advisors analyze market trends, evaluate risk metrics, and handpick products to maximize your returns.
<br/><br/>Customized Plans: Every client is unique, and so is our approach. We design investment plans that align with your financial objectives, risk appetite, and timelines.
<br/><br/>Transparent Process: We believe in building trust through complete transparency. You’ll always know where your money is going and how it’s performing.
<br/>
<br/>
What Sets Us Apart?
<br/>
<br/>Higher Returns: Our investments consistently earn 50% more than standard secured products, making your money work harder for you.
<br/>
<br/>Market Insights: Leveraging cutting-edge analytics, we stay ahead of market trends to secure the best opportunities.
<br/>
<br/>Dedicated Support: Our team is available to guide you every step of the way, ensuring clarity and confidence in your investment journey.

      </p>
    </section>
  );
}
